import { ref, onBeforeUnmount } from 'vue';
import { Shopflow, EVENTS, PLUGIN_EVENTS, type ScanKeyEvent } from './index';

const removeListener = ref<() => void>(null);
const state = { is_running: false };

export const useKeyEvent = () => {
  const unsubscribeCallback = ref<(() => void) | null>(null);

  const setEventKeys = async (keys: number[]) => {
    const { success } = await Shopflow.setEventKeys({ keys });

    return success;
  }

  const start = async () => {
    if (state.is_running) return;

    const { remove } = await Shopflow.addListener(PLUGIN_EVENTS.SCAN_KEY_EVENT, event => {
      dispatchEvent(new CustomEvent(PLUGIN_EVENTS.SCAN_KEY_EVENT, { detail: event }));
    });

    state.is_running = true;
    removeListener.value = remove;
    Shopflow.startKeyEventListener();
  }

  const stop = async () => {
    Shopflow.stopKeyEventListener();

    if (removeListener.value) {
      removeListener.value();
      removeListener.value = null;
    }

    state.is_running = false;
    unsubscribe();
  }

  const subscribe = (callback: (event: ScanKeyEvent) => void) => {
    unsubscribe();

    const listener = (event: CustomEvent<ScanKeyEvent>) => {
      callback(event.detail);
    }

    window.addEventListener(EVENTS.SCAN_KEY_EVENT, listener);

    unsubscribeCallback.value = () => {
      window.removeEventListener(EVENTS.SCAN_KEY_EVENT, listener);
    }
  }

  const unsubscribe = () => {
    if (unsubscribeCallback.value) {
      unsubscribeCallback.value();
      unsubscribeCallback.value = null;
    }
  }

  const isRunning = () => state.is_running;

  onBeforeUnmount(unsubscribe);

  return {
    start,
    stop,
    isRunning,
    subscribe,
    unsubscribe,
    setEventKeys
  }
}